import { Injectable, inject } from '@angular/core';
import { WINDOW } from './window.factory';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    private readonly window = inject<Window>(WINDOW);

    DEFAULT_LOCALE: string;
    VAS_CONTEXT_PATH: string;
    DAS_VAS_CONTEXT_PATH: string;
    APP_CONTEXT_PATH: string;
    LOGIN_URI: string;
    RESERVATION_LANDING_URI: string;
    ANNUAL_PASS_CME_URI: string;
    ITINERARY_URI: string;
    EARLY_ENTRY_URI: string;
    EXTENDED_EVENING_URI: string;
    LINK_TICKETS_URI: string;
    BUY_TICKETS_URI: string;
    LINK_PACKAGE_URI: string;
    AVAILABILITY_CALENDAR_URI: string;
    MAP_URI: string;
    PAGE_TITLE: string;
    APP_ID: string;
    BRAND: string;
    PARTY_LIMIT: number;
    ENABLE_TIMES: boolean;
    ENABLE_CIMA_ANALYTICS: boolean;
    ENABLE_CIMA_LOGGING: boolean;
    SYNDICATED_HEADER_URL: string;
    LAUNCHDARKLY_CLIENT_ID: string;

    constructor() {

        const config = this.window['__parkPassConfig'] || {};

        Object.keys(config).forEach(key => {
            this[key] = config[key];
        });

    }

}
